/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EDIT LABELS : STYLES --------------- ++++++++++ */
export default theme => ({
    editlabels: {
        maxWidth: pxToEm(432),
        '& .accent': {
            '& .accentitem': {
                display: 'block',
                opacity: 'inherit',
                marginBottom: pxToEm(5)
            }
        }

    }
});
